import { useState } from "react";

export default function Tasks({ value, onChange }) {
  const [newTask, setNewTask] = useState("");

  const addTask = () => {
    if (!newTask.trim()) return;
    onChange([...value, { title: newTask.trim(), done: false }]);
    setNewTask("");
  };

  const toggleTask = (index) => {
    const updated = value.map((task, i) =>
      i === index ? { ...task, done: !task.done } : task
    );
    onChange(updated);
  };

  const removeTask = (index) => {
    const updated = value.filter((_, i) => i !== index);
    onChange(updated);
  };

  return (
    <div>
      <h3>✅ Zadaci</h3>

      <div className="input-row">
        <input
          type="text"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          placeholder="Novi zadatak..."
          onKeyDown={(e) => e.key === "Enter" && addTask()}
        />
        <button className="add" onClick={addTask}>Dodaj</button>
      </div>

      <ul className="item-list">
        {value.map((task, index) => (
          <li key={index}>
            <label>
              <input
                type="checkbox"
                checked={task.done}
                onChange={() => toggleTask(index)}
              />
              <span style={{ textDecoration: task.done ? "line-through" : "none" }}>
                {task.title}
              </span>
            </label>
            <button className="danger" onClick={() => removeTask(index)}>✕</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
